export const TOTAL_MARKS = [
  { id: 1, value: '15' },
  { id: 2, value: '20' },
  { id: 3, value: '40' },
  { id: 4, value: '60' },
];
